import { ReactElement } from 'react';
import { IconPrize, IconLinked, IconOrganization } from '@op/opds.opux-icons/misc';
import { IconDelete, IconSettings } from '@op/opds.opux-icons/action';
import { Message } from '@messageformat/react';
import { Col, Row } from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import InfoSection from './InfoSection';
import InfoTextBox from '../InfoTextBox';

const infoTextBoxItems = [
  { icon: IconLinked, messageId: 'course8.part3.infotexts.0.title' },
  { icon: IconDelete, messageId: 'course8.part3.infotexts.1.title' },
  { icon: IconPrize, messageId: 'course8.part3.infotexts.2.title' },
  { icon: IconOrganization, messageId: 'course8.part3.infotexts.3.title' },
  { icon: IconSettings, messageId: 'course8.part3.infotexts.4.title' },
];

const PartThree = (): ReactElement => {
  return (
    <>
      <div className="investoracademy-number" style={{ marginTop: space.xxl }}>
        3
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.large,
          paddingTop: space.small,
        }}
      >
        <Message id="course8.part3.title" />
      </h2>
      <Row style={{ margin: 0 }}>
        <Col md={6} xs={12} className="investoracademy-multi-column-left">
          <InfoTextBox titleId="course8.part3.infobox1.title" items={infoTextBoxItems} />
        </Col>
        <Col
          md={6}
          xs={12}
          className="investoracademy-multi-column-right investoracademy-text-paragraph"
        >
          <Message id="course8.part3.infobox_additional" />
        </Col>
      </Row>
      <Row style={{ margin: 0 }} className="investoracademy-text-paragraph">
        <Col
          md={6}
          xs={12}
          className="investoracademy-narrow-column-odd investoracademy-multi-column-left"
          style={{ marginTop: space.large }}
        >
          <InfoSection
            icon={<IconLinked size="large" />}
            titleId="course8.part3.infotexts.0.title"
            bodyId="course8.part3.infotexts.0.body"
          />
        </Col>
        <Col
          md={6}
          xs={12}
          className="investoracademy-narrow-column-even investoracademy-multi-column-right"
          style={{ marginTop: space.large }}
        >
          <InfoSection
            icon={<IconDelete size="large" />}
            titleId="course8.part3.infotexts.1.title"
            bodyId="course8.part3.infotexts.1.body"
            body2Id="course8.part3.infotexts.1.body2"
          />
        </Col>
      </Row>
      <Row style={{ margin: 0 }} className="investoracademy-text-paragraph">
        <Col
          md={6}
          xs={12}
          className="investoracademy-narrow-column-odd investoracademy-multi-column-left"
          style={{ marginTop: space.large }}
        >
          <InfoSection
            icon={<IconPrize size="large" />}
            titleId="course8.part3.infotexts.2.title"
            bodyId="course8.part3.infotexts.2.body"
          />
        </Col>
        <Col
          md={6}
          xs={12}
          className="investoracademy-narrow-column-even investoracademy-multi-column-right"
          style={{ marginTop: space.large }}
        >
          <InfoSection
            icon={<IconOrganization size="large" />}
            titleId="course8.part3.infotexts.3.title"
            bodyId="course8.part3.infotexts.3.body"
          />
        </Col>
      </Row>
      <div style={{ marginTop: space.large }}>
        <InfoSection
          icon={<IconSettings size="large" />}
          titleId="course8.part3.infotexts.4.title"
          bodyId="course8.part3.infotexts.4.body"
        />
      </div>
    </>
  );
};

export default PartThree;
